module.exports = __webpack_public_path__ + "static/img/2.d4c0993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/2.png
// module id = 9m10
// module chunks = 0